import { toast, Zoom } from "react-toastify";
import jwtAxios from "../apiAxios/axios";
import { Link, useNavigate } from "react-router-dom";

export async function makeRequest(vbeln) {
    const response = await jwtAxios.post("users/fetch-invoice", { vbeln });
    return response.data;
}


export async function makeCreateInvoiceReport(invoiceData) {

  try {
    const response = await jwtAxios.post('users/create-masterinvoice', invoiceData);

    // Extract data from response
    const {  masterInvoiceNumber, invoice } = response.data;

    // Format the invoice numbers into a comma-separated string
    const invoiceList = invoice.join(", ");
 
    // Show success message in toast
   
toast.success(
  <div
    className="cursor-pointer"
  >
    Master Invoice created successfully with ID{" "}
    <Link to={`/master-invoice-details/${masterInvoiceNumber}`} className="font-bold">{masterInvoiceNumber}</Link> containing invoices:{" "}
    {invoiceList}
  </div>,
  {
    position: "top-right",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false, // Prevents auto closing on click, allowing navigation
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    transition: Zoom,
  }
);
    return response;
  } catch (error) {
    toast.error(error.response?.data?.message || "Error creating invoice");
    console.error(error, "Error creating data");
  }
}



export async function makeFetchInvoiceData(invoiceNumber) {
  const response = await jwtAxios.get(`users/fetch-invoice/${invoiceNumber}`);
  return response.data;
}

export async function makeDetailedFetchInvoiceData(invoiceNumber) {
  const response = await jwtAxios.get(`users/fetch-detailed-invoice/${invoiceNumber}`);
  return response.data;
}

export async function makeCreateMilestone(invoiceId,milestoneData,advance,retention){
  try{
    const response = await jwtAxios.post(`users/create-milestone/${invoiceId}`,{milestones:milestoneData,advance,retention})
    toast.success(`Milestones created successfully`,{
      position: "top-right",
      autoClose: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: "dark",
      transition: Zoom,
      });
    return response.data
  }catch(err){
    toast.error(`Something went wrong please try again!`,{
      position: "top-right",
      autoClose: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: "dark",
      transition: Zoom,
      });
  }
}

export async function makeUpdateMilestone(milestoneId,newStatus,invoiceId){
  try{
    const response = await jwtAxios.put(`users/milestones/${milestoneId}/invoices/${invoiceId}`,{status:newStatus})
    toast.success(`Milestones Updated successfully`,{
      position: "top-right",
      autoClose: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: "dark",
      transition: Zoom,
      });
    return response.data
  }catch(err){
    toast.error(`Something went wrong please try again!`,{
      position: "top-right",
      autoClose: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: "dark",
      transition: Zoom,
      });
  }
}


export async function makeDeleteMilestone(invoiceId,token){
  console.log(token,"adkflaskf")
  try{
    const response = await jwtAxios.post(`users/invoices/${invoiceId}/milestones`,{token})
    toast.success(`Milestones deleted successfully`,{
      position: "top-right",
      autoClose: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: "dark",
      transition: Zoom,
      });
    return response.data
  }catch(err){
    console.log(err)
    toast.error(err.response.data.message||`Something went wrong please try again!`,{
      position: "top-right",
      autoClose: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: "dark",
      transition: Zoom,
      });
  }
}


export async function makeDeleteMasterInvoice(invoiceId,token){
  try{
    const response = await jwtAxios.post(`users/delete-masterinvoice/${invoiceId}`,{token})
    toast.success(`Master Invoice deleted successfully`,{
      position: "top-right",
      autoClose: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: "dark",
      transition: Zoom,
      });
    return response.data
  }catch(err){
    console.log(err)
    toast.error(err.response.data.message||`Something went wrong please try again!`,{
      position: "top-right",
      autoClose: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: "dark",
      transition: Zoom,
      });
  }
}


export const fetchInvoices = async (activeTab) => {
        try {
            const response = await jwtAxios.get(`/users/fetch-deleted-log?type=${activeTab}`);
            return response.data.logs // Adjust based on your API response
        } catch (err) {
            return err
        }
    };
